/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Big_Cute_Worm_EmbraceInputs */

const en_big_cute_worm_embrace = /** @type {(inputs: Big_Cute_Worm_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This report was created with an older version of Kultify and is no longer supported. Please contact support for assistance.`)
};

const de_big_cute_worm_embrace = /** @type {(inputs: Big_Cute_Worm_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Bericht wurde mit einer älteren Version von Kultify erstellt und wird nicht mehr unterstützt. Bitte kontaktieren Sie den Support für Hilfe.`)
};

/**
* | output |
* | --- |
* | "This report was created with an older version of Kultify and is no longer supported. Please contact support for assistance." |
*
* @param {Big_Cute_Worm_EmbraceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const big_cute_worm_embrace = /** @type {((inputs?: Big_Cute_Worm_EmbraceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Big_Cute_Worm_EmbraceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_big_cute_worm_embrace(inputs)
	return de_big_cute_worm_embrace(inputs)
});